import { connect } from 'react-redux';
import { actions } from 'app-webtech-core/actions';
import { PlutoApplicationContainer } from './PlutoApplication';
import { applicationSetAppInfo as setAppInfo } from '../actions/setAppInfo';

const mapDispatchToProps = (dispatch) => ({
  appLaunch: () => dispatch(actions.application.appLaunch()),
  setAppInfo: (appName, appVersion) => dispatch(setAppInfo({ appName, appVersion })),
});

export const PlutoApplication = connect(null, mapDispatchToProps)(PlutoApplicationContainer);
